export function changePage(location) {
    window.location.href = location
}